import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';

import StudentFormView from './view';
import { closeModal } from 'actions/modal';

import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';
import { FORM_ACTIONS, USER_TAB } from 'constants/form';

class StudentForm extends PureComponent {
  constructor(props) {
    super(props);
    const { data, formType, tab } = this.props;
    this.state = {
      formType: formType || FORM_ACTIONS.CREATE,
      tab: tab || USER_TAB.ACCOUNT,
      student: data,
      message: null,
      isFirst: true,
      isLast: tab === Object.keys(USER_TAB).length - 1,
    };
  }

  changeTab = ({ tab, type, data, message }) => {
    const { actions } = this.props;
    const { tab: lastTab, formType, student } = this.state;
    const newTab = tab === 0 ? 0 : tab || lastTab;

    if (tab < 0 || tab >= Object.keys(USER_TAB).length) {
      actions.closeModal();
      return;
    }
    this.setState({
      tab: newTab,
      formType: type || formType,
      student: data || student,
      message: message || null,
      isFirst: newTab === 0,
      isLast: newTab === Object.keys(USER_TAB).length - 1,
    });
  };

  render() {
    const { userConfig, batchConfig, programs, livePrograms } = this.props;

    let filteredPrograms = [];

    if (livePrograms.length) {
      filteredPrograms = livePrograms;
    } else if (programs.length) {
      filteredPrograms = programs.filter(item => item.is_live === true);
    }

    return (
      <StudentFormView
        {...this.state}
        userConfig={userConfig}
        batchConfig={batchConfig}
        programs={filteredPrograms}
        onNavigate={this.changeTab}
      />
    );
  }
}

export default connect(
  ({ configs, programs }) => {
    const programQueryParam = {
      is_live: true,
    };

    return {
      userConfig: store.get(configs, USER_CONFIG).data,
      batchConfig: store.get(configs, BATCHES_CONFIG).data,
      programs: store.getAll(programs).data,
      livePrograms: store.getAll(programs, programQueryParam).data,
    };
  },
  dispatch => ({
    actions: bindActionCreators({ closeModal }, dispatch),
  }),
)(StudentForm);
